const ADMIN_MESSAGES = {
  LOGIN_SUCCESSFUL: "Admin login successful",
  LOGOUT_SUCCESSFUL: "Admin logged out successfully",
  FORGOT_PASSWORD_SUCCESSFUL:
    "Password reset instructions have been sent to your email",
  RESET_PASSWORD_SUCCESSFUL: "Your password has been reset successfully",
  ADMIN_CREATED: "Admin created successfully",
  ADMIN_UPDATED: "Admin updated successfully",
  ADMIN_SUSPENDED: "Admin has been suspended",
  ADMIN_UNSUSPENDED: "Admin suspension has been lifted",
  ADMIN_ACTIVATED: "Admin has been activated",
  ADMIN_DEACTIVATED: "Admin has been deactivated",
  PASSWORD_CHANGED: "Password changed successfully",
  UNEXPECTED_ERROR: "An unexpected error occurred. Please try again",
};

export default ADMIN_MESSAGES;
